import React from "react";
import { Field } from "formik";
import Tooltip from "@mui/material/Tooltip";
import WarningIcon from "@mui/icons-material/Warning";
import { pink } from "@mui/material/colors";
import {
  getLabelAndValue,
  processString,
} from "../../CommonFuntion/SchemaValidation";

const TableILISelectField = ({
  element,
  option = [],
  error = {},
  id,
  tdkeys,
  rowkeys,
  tableName,
  name,
  errorBorder,
  values,
  disabled,
}) => {
  if (element.prefix !== "ILI") {
    return null;
  }
  const label = values?.[tableName]?.[tdkeys]?.[name];
  let Category, ImageID;
  if (label?.length > 0) {
    let data;
    if (label?.startsWith("[")) {
      data = option?.find((x) => x.value.split("|")[0] === label)?.value;
    } else {
      data = option?.find((x) => x.label === label)?.value;
    }

    const parts = getLabelAndValue(data);
    if (parts?.length >= 3) {
      // Format: label|Category|ImageID (e.g., [CAN]DO NOT BLEACH|Coin_Cin_Care|CIN05244)
      Category = parts[1];
      ImageID = parts[2];
    } else {
      [ImageID, Category] = parts || [];
      const { code } = processString(ImageID);
      ImageID = code ? code : ImageID;
    }
  }

  return (
    <>
      <div className="wrapper" data-testid="TableILISelectField">
        <div>
          <Field
            data-testid="TableILIField"
            as="select"
            className={`tableInput ${errorBorder}`}
            id={id + tdkeys + 1}
            rowkeys={tdkeys}
            tdkeys={rowkeys}
            name={`${tableName}[${tdkeys}].${name}`}
            disabled={disabled}
          >
            <option value=""></option>
            {option.map((i, index) => (
              <option
                key={index}
                value={
                  i.value?.split("|")[0].startsWith("[")
                    ? i.value.split("|")[0]
                    : i.label
                }
              >
                {i.label}
              </option>
            ))}
          </Field>
          {error?.[name] && (
            <span className="icon">
              <Tooltip title={error[name]}>
                <WarningIcon sx={{ color: pink[500] }} />
              </Tooltip>
            </span>
          )}
        </div>
      </div>
      <span>
        {Category && (
          <div>
            <img
              className="ImageList"
              alt="Image not available"
              src={
                process.env.REACT_APP_SITE_URL +
                `/Pages/Utils/ShowImage.ashx?Category=${Category}&ImageID=${ImageID}`
              }
            />
          </div>
        )}
      </span>
    </>
  );
};

export default TableILISelectField;
